export default class ProvinceActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_PROVINCE='GET_HELPER_PROVINCE';
  static SUCCESS_DATA='SUCCESS_DATA';

  static submit(){
    return {
      type: ProvinceActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: ProvinceActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: ProvinceActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: ProvinceActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: ProvinceActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: ProvinceActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: ProvinceActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: ProvinceActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: ProvinceActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: ProvinceActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: ProvinceActions.GET_HELPER_PROVINCE,
      payload:data
    };
  }
}